import { makeStyles } from 'tss-react/mui';

// Constants
import {
  FONT_WEIGHT_REGULAR,
  FONT_WEIGHT_SEMIBOLD,
} from '../../../constants/typography';

export const useStyles = makeStyles()(
  (theme, { isKiteUser, positionStatic } = {}) => ({
    label: {
      height: 24,
      display: 'flex',
      alignItems: 'center',
      backgroundColor: theme.palette.lightGrey,
      borderRadius: 4,
      color: isKiteUser ? theme.palette.primary2 : theme.palette.primary1,
      fontSize: 14,
      fontWeight: isKiteUser ? FONT_WEIGHT_REGULAR : FONT_WEIGHT_SEMIBOLD,
      padding: `${theme.spacing(0.5)} ${theme.spacing(0.8)}`,
      position: positionStatic ? 'static' : 'absolute',
      left: theme.spacing(2),
      top: theme.spacing(2),
      zIndex: 10,
      [theme.breakpoints.down('md')]: {
        height: 20,
        fontSize: 12,
        lineHeight: '11px',
        left: theme.spacing(1),
        top: theme.spacing(1),
      },
    },
  }),
);
